import { render, staticRenderFns } from "./CorporateAccountAdmins.vue?vue&type=template&id=64ab95d0&scoped=true"
import script from "./CorporateAccountAdmins.vue?vue&type=script&lang=js"
export * from "./CorporateAccountAdmins.vue?vue&type=script&lang=js"
import style0 from "./CorporateAccountAdmins.vue?vue&type=style&index=0&id=64ab95d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab95d0",
  null
  
)

export default component.exports